"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator"));

require("core-js/modules/es6.function.name");

var _apolloClient = require("@/apollo/apolloClient");

var _userQuery = require("@/apollo/queries/user-query");

var _auth = require("../../utils/auth");

var state = {
  myUser: []
};
var mutations = {
  CREATE_USER_BY_UID: function CREATE_USER_BY_UID(state, data) {
    var user = data.user;

    if (user) {
      user.companyCount = '';
      user.companyName = '';
      user.companyID = '';
      user.roleName = '';
      user.roleID = '';

      if (user.role) {
        user.roleName = user.role.name;
        user.roleID = user.role.id;
      }

      user.planMaxUser = '';
      user.planName = '';

      if (user.zone) {
        if (user.zone.plan) {
          user.planMaxUser = user.zone.plan.max_user;
          user.planName = user.zone.plan.name;
        }

        user.companyName = user.zone.name;
      }

      user.companyCount = data.user_aggregate.aggregate.count;
      user.companyID = (0, _auth.getZoneId)();
    }

    state.myUser = user;
  }
};
var actions = {
  getMyUser: function () {
    var _getMyUser = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(_ref) {
      var commit, res;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit;
              _context.t0 = _apolloClient.apolloClient;
              _context.t1 = _userQuery.GET_USER;
              _context.next = 5;
              return (0, _auth.getUserUID)();

            case 5:
              _context.t2 = _context.sent;
              _context.next = 8;
              return (0, _auth.getZoneId)();

            case 8:
              _context.t3 = _context.sent;
              _context.t4 = {
                uid: _context.t2,
                zoneId: _context.t3
              };
              _context.t5 = {
                query: _context.t1,
                variables: _context.t4
              };
              _context.next = 13;
              return _context.t0.query.call(_context.t0, _context.t5);

            case 13:
              res = _context.sent;

              if (!res.data) {
                _context.next = 19;
                break;
              }

              commit('CREATE_USER_BY_UID', res.data);
              return _context.abrupt("return", res.data.user);

            case 19:
              throw res.errors[0].message;

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function getMyUser(_x) {
      return _getMyUser.apply(this, arguments);
    }

    return getMyUser;
  }()
};
var _default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};
exports.default = _default;